export function handleGuiVersionOutdated({ dispatch, rideInformationId, delayMs = 7000 }) {
  dispatch('showModalWithParameters', {
    errorNumber: 'gui_version_outdated',
    type: 'textConverter'
  });

  setTimeout(() => {
    if (rideInformationId) {
      window.location.href = '/single_ride_with_map/' + rideInformationId;
    } else {
      window.location.reload();
    }
  }, delayMs);
}
